import { useRef } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useConstants } from '../hooks/UseConstants';

function ListPageToolbar({ title, data = [], selected, onChange, onSearch }) {
    const scrollRef = useRef(null);
    const searchRef = useRef();
    const theme = useTheme();
    const { language } = useConstants();

    const handleScrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: 100, behavior: 'smooth' });
        }
    };
    const handleScrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: -100, behavior: 'smooth' });
        }
    };

    return (
        <Box sx={{ backgroundColor: theme.palette.background.paper }} className="rounded-xl px-3 py-3 mb-4 shadow-sm">
            {title ? <Typography variant="h5" className="!font-bold !mb-3">{title}</Typography> : null}
            <Box className="flex flex-wrap gap-2 items-center mb-3">
                <Box className="relative flex-1 min-w-[200px]">
                    <input
                        ref={searchRef}
                        style={{ backgroundColor: theme.palette.background.default }}
                        className="w-full h-12 rounded-md border indent-12 outline-none"
                        type="text"
                        placeholder={language === 'ar' ? 'بحث...' : 'Search...'}
                    />
                    <SearchOutlinedIcon
                        className="absolute top-1/2 -translate-y-1/2 text-gray-500"
                        sx={{ right: language === 'en' ? 'auto' : 12, left: language === 'en' ? 12 : 'auto' }}
                    />
                </Box>
                <Button
                    variant="contained"
                    onClick={() => onSearch(searchRef.current?.value || '')}
                    className="!bg-gray-800"
                >
                    {language === 'ar' ? 'بحث' : 'Search'}
                </Button>
            </Box>
            {data.length > 0 && (
                <Box className="relative">
                    <Box ref={scrollRef} className="w-full overflow-x-scroll flex none-view-scroll gap-2 pb-1">
                        {
                            data.map((item, index) =>
                                <Box
                                    key={index}
                                    onClick={() => item.id === selected ? onChange(null) : onChange(item.id)}
                                    sx={{
                                        backgroundColor: item.id === selected ? '#bfdbfe' : theme.palette.background.default,
                                        cursor: 'pointer',
                                    }}
                                    className="w-fit px-3 py-1 rounded-lg whitespace-nowrap"
                                >
                                    {language === 'en' ? item.name_en : item.name_ar}
                                </Box>
                            )
                        }
                    </Box>
                    <Button
                        onClick={handleScrollLeft}
                        sx={{ minWidth: 32, position: 'absolute', top: '50%', left: 0, transform: 'translateY(-50%)' }}
                    >
                        <ArrowBackIosNewIcon fontSize="small" />
                    </Button>
                    <Button
                        onClick={handleScrollRight}
                        sx={{ minWidth: 32, position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }}
                    >
                        <ArrowForwardIosIcon fontSize="small" />
                    </Button>
                </Box>
            )}
        </Box>
    );
}

export default ListPageToolbar;
